import type { ForwardedRef, ReactNode } from 'react';
import { forwardRef } from 'react';

import type { UnpluginIcon } from '@adflow/frontend/ui-assets';
import { theme } from '@adflow/frontend/ui-theme';

import type { LineClampProps } from './LineClamp';
import { LineClamp } from './LineClamp';

export interface IconWithTextProps extends Omit<LineClampProps, 'children'> {
	Icon: UnpluginIcon;
	text: ReactNode;
	link?: string;
}

export const IconWithText = forwardRef(function IconWithTextRender(
	{ Icon, text, link, lines = 2, ...forwardedProps }: IconWithTextProps,
	forwardedRef: ForwardedRef<HTMLDivElement>
) {
	return (
		<div
			ref={forwardedRef}
			css={{ display: 'flex', alignItems: 'center', maxWidth: '100%' }}
		>
			<a
				target={link ?? '_blank'}
				rel={link ?? 'noreferrer noopener'}
				href={link}
				css={{
					marginTop: '0.1em',
					color:
						link === undefined
							? theme.colors.text.secondary
							: theme.colors.palettes.primary.main,
					marginRight: '0.5rem',
				}}
			>
				<Icon
					css={{
						color: theme.colors.text.secondary,
					}}
					height={18}
					width={18}
				/>
			</a>
			<LineClamp
				css={{
					color: theme.colors.text.primary,
					fontSize: '0.875rem',
					overflowWrap: 'break-word',
				}}
				lines={lines}
				{...forwardedProps}
			>
				{text}
			</LineClamp>
		</div>
	);
});
